<template>
  <a-card title="基本信息" class="card">
    <a-skeleton v-if="!baseInfo || !schema" active />
    <card-view v-else :column="column" :source-data="baseInfo" :schema="schema">
      <template v-slot:company-type="slotProps">
        <a-popover trigger="click">
          <template slot="content">
            <a-table
              rowKey="code"
              :columns="relationColumns"
              :data-source="baseInfo && baseInfo.relations"
              :pagination="false"
              size="small"
            >
              <template slot="exposure" slot-scope="exposure">
                {{ exposure | formatAmount }}
              </template>
            </a-table>
          </template>
          <a-button type="link" v-show="slotProps.item.value != 0">
            {{ getCompanyTypeText(slotProps.item.value) }}
          </a-button>
        </a-popover>
      </template>

      <template v-slot:limit-control-amount="slotProps">
        <div>
          <span v-if="slotProps.item.value !== ''" style="color: red;">
            <!-- {{slotProps.item}} -->
            Net AR 超{{ slotProps.item.value | formatAmount }}元控货
          </span>
          <span v-else style="color: red;">
            无
          </span>
        </div>
      </template>

      <template v-slot:riskWarning="slotProps">
        <div style="color:red">
          {{ slotProps.item.value }}
        </div>
      </template>

      <!-- 额外详情信息 -->
      <template v-slot:link="slotProps">
        <a-button type="link" @click="jumpPage(slotProps.item)">
          <span v-if="slotProps.item.filter === 'formatAmount'">
            {{ slotProps.item.value | formatAmount }}
          </span>
          <span v-else>{{ slotProps.item.value }}</span>
        </a-button>
      </template>

      <!-- 保险覆盖率 -->
      <template v-slot:insurance-coverage="slotProps">
        <template v-if="baseInfo.companyType">
          <a-popover title="保险覆盖率" trigger="click">
            <template slot="content">
              <insurance-coverage
                :company-code="baseInfo.code"
                :company-type="baseInfo.companyType"
              />
            </template>
            <a-button type="link">
              {{ slotProps.item.value }}
            </a-button>
          </a-popover>
        </template>
        <div v-else>{{ slotProps.item.value }}</div>
      </template>
    </card-view>
  </a-card>
</template>

<script>
import { CardView } from 'lxfintech-fe'
import InsuranceCoverage from './InsuranceCoverage/index.vue'
import { SET_COMPANY } from 'config/mutation-types/app'
import { mapMutations } from 'vuex'
import { queryBase } from './api'

export default {
  name: 'BaseInfo',
  data() {
    return {
      companyCode: '',
      column: { xxl: 3, xl: 3, lg: 2, md: 1, sm: 1, xs: 1 },
      relationColumns: [
        {
          title: '公司ID',
          dataIndex: 'code',
        },
        {
          title: '公司名称',
          dataIndex: 'name',
        },
        {
          title: '信用限额敞口（元）',
          dataIndex: 'exposure',
          scopedSlots: { customRender: 'exposure' },
        },
      ],
    }
  },
  props: ['baseInfo', 'schema'],
  mounted() {},
  created() {
    window.eventBus.$on('changeLimitCondition', this.listentLimitCondition)
    const { companyCode } = this.$route.params
    if (companyCode) {
      this.companyCode = companyCode
      this.getBaseInfo(companyCode)
    }
  },
  beforeDestroy() {
    window.eventBus.$off('changeLimitCondition', this.listentLimitCondition)
  },
  methods: {
    ...mapMutations('app', [SET_COMPANY]),
    async getBaseInfo(companyCode) {
      try {
        const { data } = await queryBase(companyCode)
        console.log(111111, data)
      } catch (error) {
        console.error(error)
      }
    },
    listentLimitCondition(e) {
      this.exceed = e.exceed
    },
    getCompanyTypeText(type) {
      return `${type == 1 ? '母' : '子'}公司（共${
        this.baseInfo.relations.length
      }家${type == 1 ? '子' : '母'}公司)`
    },
    // TODO:AR超限控货?
    jumpPage(item) {
      const { name, code, companyId } = this.baseInfo
      this.SET_COMPANY({ name, code })
      const path = `${item.jumpUrl}/${companyId}`
      let routeUrl = this.$router.resolve({
        path,
      })
      window.open(routeUrl.href, '_blank')
    },
  },
  components: {
    CardView,
    InsuranceCoverage,
  },
}
</script>

<style scoped lang="less">
/deep/ .ant-btn-link {
  padding: 0;
}
</style>
